var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_573_68171)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.1283,
    cy: 11.2982,
    rx: 10.5737,
    ry: 10.6263,
    fill: "black",
    fillOpacity: 0.52
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5861 7.8257C13.5876 6.82343 12.1726 6.24543 10.6166 6.4053C8.36841 6.63281 6.51841 8.46519 6.26725 10.7219C5.93033 13.7041 8.22752 16.219 11.125 16.219C13.0792 16.219 14.7577 15.0692 15.5418 13.4151C15.7378 13.0031 15.4438 12.5296 14.9904 12.5296C14.7638 12.5296 14.5494 12.6526 14.4514 12.8555C13.7591 14.3497 12.099 15.2967 10.2858 14.8908C8.92586 14.5895 7.82934 13.4766 7.54142 12.1115C7.02685 9.72573 8.83397 7.61049 11.125 7.61049C12.1419 7.61049 13.0486 8.03477 13.7101 8.705L12.7851 9.63349C12.3992 10.0209 12.6687 10.685 13.2139 10.685H15.4131C15.75 10.685 16.0257 10.4083 16.0257 10.0701V7.8626C16.0257 7.31534 15.3641 7.03864 14.9782 7.42602L14.5861 7.8257Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_573_68171",
    x: -29.4425,
    y: -29.3253,
    width: 81.1429,
    height: 81.2469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 14.9986
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_573_68171"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_573_68171",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplay);
export default __webpack_public_path__ + "static/media/replay.4a47fcf7c033c46866fc9330dce1d9cd.svg";
export { ForwardRef as ReactComponent };